import React, { useEffect, useState, useCallback } from "react";
import { MoveLeft } from "lucide-react";
import inspection from "../../assets//svg/Inspection/viewInspection.svg";
import "../Vehicles/Vehicle_list/List.css";
import redLocation from "../../assets//svg/Inspection/redLocation.svg";
import { useNavigate, useLocation } from "react-router-dom";
import tata from "../../assets/Vehicles/tata.png";
import calender from "../../assets/svg/Inspection/calenderWithClock.svg";
import fail from "../../assets//svg/Inspection/fail.svg";
import pass from "../../assets//svg/Inspection/pass.svg";
import { Table } from "../Vehicles/Vehicle_list/_components/Table";
import { getInspectionDetailsApi, getInspectionHistoryListApi } from "./inspection-api.js";
import ReactPaginate from "react-paginate";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import lar from "../../assets/svg/lar.svg";
import rar from "../../assets/svg/rar.svg";
import { useReactTable, getCoreRowModel, getSortedRowModel, getFilteredRowModel, getPaginationRowModel, flexRender } from "@tanstack/react-table";
import Dropdown from "react-bootstrap/Dropdown";
import down from "../../assets/Vehicles/chevron_down.png";
import { useGlobal } from "../../GlobalContext.js";

export const ViewInspection = () => {
  const { rolePermissionList, userType } = useGlobal();

  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};

  useEffect(() => {
    if (id != null && id !== undefined) {
      getInspectionDetails();
    }
  }, [id]);

  const [inspectionDetail, setInspectionDetail] = useState({});

  const getInspectionDetails = async () => {
    try {
      const response = await getInspectionDetailsApi(id);

      if (response.data.success === true) {
        setInspectionDetail(response.data.inspection ?? {});
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const details = [
    {
      label: "Start date & Time",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={calender} alt="calender" />
          <span>
            {inspectionDetail.start_date} {inspectionDetail.start_time}{" "}
          </span>
        </div>
      ),
    },
    {
      label: "Summitted date & time",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={calender} alt="calender" />
          <span style={{ color: "#172B4D" }}>
            {inspectionDetail.submitted_date} {inspectionDetail.submitted_time}
          </span>
        </div>
      ),
    },
    {
      label: "Kilometers",
      value: <span style={{ color: "#471070" }}>{inspectionDetail.km} KM</span>,
    },
  ];
  const columns = [
    {
      header: "VIN",
      accessorKey: "vin",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "Vehicle Name",
      accessorKey: "vehicle_name",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "License Plate",
      accessorKey: "lic_no",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "User",
      accessorKey: "user",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "Location",
      accessorKey: "location",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
  ];

  const [inspectionHistoryList, setInspectionHistoryList] = useState([]);

  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const handleRowClick = (rowData) => {
    navigate("/inspection-history/view", { state: rowData });
  };
  useEffect(() => {
    getInspectionHistoryList();
  }, [itemsPerPage, itemOffset]);
  const getInspectionHistoryList = async () => {
    try {
      /* &from_date=${fromCreatedDate}&to_date=${toCreatedDate}&status=${selectedStatus}&sort_field=${sortField}&sort_dir=${sortDir} */
      const response = await getInspectionHistoryListApi(id, `limit=${itemsPerPage}&skip=${itemOffset * itemsPerPage}`);
      if (response.data.success === true) {
        setInspectionHistoryList(response.data.histories);
        setPageCount(response.data.total_pgs);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handlePageClick = useCallback((event) => {
    const newOffset = (event.selected * itemsPerPage) % inspectionHistoryList.length;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
    setItemOffset(event.selected);
  }, []);

  const table = useReactTable({
    data: inspectionHistoryList ?? [],
    columns,

    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  return (
    <>
      <div className="">
        <div className="d-flex flex-wrap justify-content-between align-items-center bg-white p-3">
          <div className="d-flex align-items-center gap-3">
            <div
              className="border p-2 rounded-circle cursor-pointer"
              onClick={() => {
                navigate(-1);
              }}
            >
              <MoveLeft />
            </div>
            <div className="rounded-4 p-4" style={{ backgroundColor: "#F5F2FF" }}>
              <img src={inspection} alt="tata" />
            </div>
            <div>
              {/* <p className="m-0 fs-20 fw-600 mb-1">INS8738456</p> */}
              <div className="d-flex flex-wrap align-items-center">
                <span className="me-2 fs-14 fw-400" style={{ color: "#471070" }}>
                  {inspectionDetail.type ?? ""}
                </span>
                <span className="me-2" style={{ color: "#D9D9D9" }}>
                  •
                </span>
                {inspectionDetail.location && (
                  <span className="border-0 d-flex align-items-center gap-2 pagination-color py-1 px-3 rounded-pill fs-14 fw-400" style={{ backgroundColor: "#FFEFEF", color: "#172B4D" }}>
                    <img src={redLocation} alt="redlocation" />
                    {inspectionDetail.location ?? ""}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0 p-3">
          <div className="col-xl-6">
            <div className="bg-white h-100 p-3 rounded-4">
              <div className="p-3 rounded-4" style={{ backgroundColor: "#F8F8F8" }}>
                <div className="d-flex gap-3">
                  <div className="rounded-4" style={{ backgroundColor: "#E8E8E8" }}>
                    <img src={tata} alt="tata" />
                  </div>
                  <div>
                    <p className="m-0 fs-16 fw-semibold mb-1">{inspectionDetail.lic_no ?? ""}</p>
                    <div className="d-flex align-items-center">
                      <span className="me-2 fs-14 fw-400" style={{ color: "#A2A7AE" }}>
                        {inspectionDetail.vehicle_name ?? ""}
                      </span>
                      <span className="me-2">•</span>
                      {inspectionDetail.year_of_make && (
                        <span style={{ background: "#F0DBFF", color: "#A2A7AE" }} className="border-0 py-1 px-4 rounded-pill  fs-12">
                          {inspectionDetail.year_of_make ?? ""}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-4 mt-3 p-2 d-flex justify-content-start">
                  <span className="fs-13 fw-400" style={{ color: "#8790A1" }}>
                    Vehicle identification number (VIN) :
                  </span>
                  <span className="fs-14 fw-500" style={{ color: "#172B4D" }}>
                    &nbsp;{inspectionDetail.vin ?? ""}
                  </span>
                </div>
              </div>
              <p className="fs-16 fw-600 m-0 mt-3" style={{ color: "#212129" }}>
                Issue information
              </p>
              <div className="table-container rounded-4 overflow-hidden my-3">
                <table className="table table-borderless mb-0">
                  <tbody>
                    {details.map((item, index) => (
                      <tr key={index}>
                        <td className="fs-13 fw-500 w-25" style={{ color: "#49494B" }}>
                          {item.label}
                        </td>
                        <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                          {item.value}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-xl-3">
            <div className="bg-white h-100 rounded-4 p-3 mt-3 mt-xl-0">
              <p className="fs-16 fw-600" style={{ color: "#212129" }}>
                Interior details
              </p>
              {inspectionDetail?.interiors?.map((item, index) => (
                <>
                  {index !== 0 && <hr style={{ color: "#EBEBEB" }} />}
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="m-0 fs-14 fw-400" style={{ color: "#172B4D" }}>
                      {item}
                    </p>
                  </div>
                </>
              ))}
            </div>
          </div>
          <div className="col-xl-3">
            <div className="bg-white h-100 rounded-4 p-3 mt-4 mt-xl-0">
              <p className="fs-16 fw-600" style={{ color: "#212129" }}>
                Exterior details
              </p>
              {inspectionDetail?.exteriors?.map((item, index) => (
                <>
                  {index !== 0 && <hr style={{ color: "#EBEBEB" }} />}
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="m-0 fs-14 fw-400" style={{ color: "#172B4D" }}>
                      {item}
                    </p>
                  </div>
                </>
              ))}
            </div>
          </div>
          {/* Table */}
          <div className="p-3">
            <div className="table-wrapper overflow-x-auto">
              <table>
                <thead>
                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                      {headerGroup.headers.map((header) => (
                        <th key={header.id} className="px-3 py-2" onClick={header.column.getToggleSortingHandler()}>
                          {flexRender(header.column.columnDef.header, header.getContext())}
                          {header.column.getIsSorted() === "asc" && " asc"}
                          {header.column.getIsSorted() === "desc" && " des"}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody>
                  {table.getRowModel().rows.map((row, index) => (
                    <tr key={"row" + index + row.id} onClick={() => handleRowClick(row.original)}>
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id} className="px-3 py-2">
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">Records per page: &nbsp;</span>
                <Dropdown.Toggle id="dropdown-basic" className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0">
                  <span className="bg-white no-of-rows rounded-3 px-2 py-2">
                    {itemsPerPage} <img src={down} alt="" />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="my-2" style={{ minWidth: "unset", width: "30%" }}>
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        table.setPageSize(size);
                        setItemsPerPage(size);
                        setItemOffset(0);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate previousLabel={<img src={lar} className="ar3" alt="previous" />} nextLabel={<img src={rar} className="ar3" alt="next" />} breakLabel={"..."} pageCount={pageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
